export var IN_WEEK_DAY_DICTIONARY = {
  0: 'в воскресенье',
  1: 'в понедельник',
  2: 'во вторник',
  3: 'в среду',
  4: 'в четверг',
  5: 'в пятницу',
  6: 'в субботу'
};